import * as React from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import withStyles from 'react-jss';
import { ThemeType, CssType } from 'src/theming/jssTypes';

const styles = (theme: ThemeType): CssType => ({
  wrapper: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.color.semantic.text.tertiary,
    marginTop: theme.spacing[2],
  },
  row: {
    marginBottom: theme.spacing[2],
    display: 'flex',
  },
  label: {
    marginRight: theme.spacing[3],
  },
  value: {
    fontWeight: theme.typography.fontWeight.medium,
    color: theme.color.semantic.text.primary,
  },
});

const RenderVehicleDetails = (props: any) => {
  const { vehicleData = {}, classes, justify = 'end' } = props;
  const { t } = useTranslation();

  const { fleet_type: fleetType, vehicle_make_name: vehicleMake, vehicle_vendor_name: vehicleVendor } = vehicleData || {};

  return (
    <Row className={classes?.customTripModal} justify={justify}>
      <Col span={18}>
        <div className={classes.wrapper}>
          {fleetType && (
            <div className={classes.row}>
              <span className={classes.label}>{t('Fleet Type')}:</span>
              <span className={classes.value}>{fleetType}</span>
            </div>
          )}
          {vehicleMake && (
            <div className={classes.row}>
              <span className={classes.label}>{t('Vehicle Make')}:</span>
              <span className={classes.value}>{vehicleMake}</span>
            </div>
          )}
          {vehicleVendor && (
            <div className={classes.row}>
              <span className={classes.label}>{t('Vehicle Vendor')}:</span>
              <span className={classes.value}>{vehicleVendor}</span>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default withStyles(styles, { injectTheme: true })(RenderVehicleDetails);
